module.exports = __webpack_public_path__ + "img/loreto-relax.b045da97.jpg";